import { render, staticRenderFns } from "./LfsRadioBoxFree.vue?vue&type=template&id=17599f73&scoped=true&"
import script from "./LfsRadioBoxFree.vue?vue&type=script&lang=ts&"
export * from "./LfsRadioBoxFree.vue?vue&type=script&lang=ts&"
import style0 from "./LfsRadioBoxFree.vue?vue&type=style&index=0&id=17599f73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17599f73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
